import React, { useCallback, useEffect, useMemo, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Icon from '@App/themes/natucare/components/Icon/Icon';
import { ArrowLeftIcon, ArrowRightIcon } from '@App/common/components/icons/NavigationArrows';
import * as styles from './MediaBar.module.scss';
const MediaBar = ({
  label = 'OFICJALNY PARTNER',
  partners = [],
  sliderSettings = {},
  classname = ''
}) => {
  if (!label && !(partners !== null && partners !== void 0 && partners.length)) {
    return null;
  }
  const partnerCount = (partners === null || partners === void 0 ? void 0 : partners.length) || 0;
  const hasPartners = Boolean(partnerCount);
  const emblaOptions = useMemo(() => {
    var _rest$loop;
    const {
      gap,
      autoplay: _autoplay,
      hoverpause: _hoverpause,
      ...rest
    } = sliderSettings || {};
    void gap;
    void _autoplay;
    void _hoverpause;
    return {
      align: 'start',
      containScroll: 'trimSnaps',
      skipSnaps: false,
      loop: (_rest$loop = rest.loop) !== null && _rest$loop !== void 0 ? _rest$loop : false,
      ...rest
    };
  }, [sliderSettings]);
  const [emblaRef, emblaApi] = useEmblaCarousel(emblaOptions);
  const {
    0: selectedIndex,
    1: setSelectedIndex
  } = useState(0);
  const {
    0: canScrollPrev,
    1: setCanScrollPrev
  } = useState(false);
  const {
    0: canScrollNext,
    1: setCanScrollNext
  } = useState(false);
  const {
    0: scrollSnaps,
    1: setScrollSnaps
  } = useState([]);
  const carouselGap = useMemo(() => {
    const value = sliderSettings === null || sliderSettings === void 0 ? void 0 : sliderSettings.gap;
    return typeof value === 'number' ? value : 0;
  }, [sliderSettings]);
  const scrollPrev = useCallback(() => {
    emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollPrev();
  }, [emblaApi]);
  const scrollNext = useCallback(() => {
    emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollNext();
  }, [emblaApi]);
  const scrollTo = useCallback(index => {
    emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollTo(index);
  }, [emblaApi]);
  useEffect(() => {
    if (!emblaApi) {
      return undefined;
    }
    const onSelect = () => {
      setSelectedIndex(emblaApi.selectedScrollSnap());
      setCanScrollPrev(emblaApi.canScrollPrev());
      setCanScrollNext(emblaApi.canScrollNext());
      setScrollSnaps(emblaApi.scrollSnapList());
    };
    onSelect();
    emblaApi.on('select', onSelect);
    emblaApi.on('reInit', onSelect);
    emblaApi.on('resize', onSelect);
    return () => {
      emblaApi.off('select', onSelect);
      emblaApi.off('reInit', onSelect);
      emblaApi.off('resize', onSelect);
    };
  }, [emblaApi]);
  const renderPartner = (partner, index) => {
    var _ref, _partner$id;
    const key = (_ref = (_partner$id = partner === null || partner === void 0 ? void 0 : partner.id) !== null && _partner$id !== void 0 ? _partner$id : partner === null || partner === void 0 ? void 0 : partner.description) !== null && _ref !== void 0 ? _ref : index;
    const logo = partner === null || partner === void 0 ? void 0 : partner.logo;
    const description = partner === null || partner === void 0 ? void 0 : partner.description;
    const svgMarkup = typeof (logo === null || logo === void 0 ? void 0 : logo.svg) === 'string' ? logo.svg : null;
    const iconName = logo === null || logo === void 0 ? void 0 : logo.name;
    return /*#__PURE__*/React.createElement("div", {
      className: styles.rootSlide,
      key: key
    }, iconName && /*#__PURE__*/React.createElement(Icon, {
      name: iconName,
      className: styles.rootLogoIcon,
      role: logo !== null && logo !== void 0 && logo.alt ? 'img' : 'presentation',
      "aria-label": (logo === null || logo === void 0 ? void 0 : logo.alt) || undefined,
      "aria-hidden": logo !== null && logo !== void 0 && logo.alt ? undefined : 'true'
    }), (logo === null || logo === void 0 ? void 0 : logo.src) && /*#__PURE__*/React.createElement("img", {
      className: styles.rootLogo,
      src: logo.src,
      alt: logo.alt || '',
      loading: "lazy",
      decoding: "async",
      width: logo.width,
      height: logo.height
    }), !iconName && !(logo !== null && logo !== void 0 && logo.src) && svgMarkup && /*#__PURE__*/React.createElement("span", {
      className: styles.rootLogo,
      role: logo !== null && logo !== void 0 && logo.alt ? 'img' : undefined,
      "aria-label": logo === null || logo === void 0 ? void 0 : logo.alt,
      dangerouslySetInnerHTML: {
        __html: svgMarkup
      }
    }), description && /*#__PURE__*/React.createElement("p", {
      className: styles.rootText,
      dangerouslySetInnerHTML: {
        __html: description
      }
    }));
  };
  const rootClassname = `${styles.root} ${classname || ''}`.trim();
  return /*#__PURE__*/React.createElement("section", {
    className: rootClassname
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootMain
  }, label && /*#__PURE__*/React.createElement("h2", {
    className: styles.rootHeading
  }, label), /*#__PURE__*/React.createElement(Icon, {
    name: "v4_mediabar_hebe"
  }), /*#__PURE__*/React.createElement("p", {
    className: styles.rootText
  }, "Znajdziesz nas w drogeriach Hebe")), hasPartners && /*#__PURE__*/React.createElement("div", {
    className: styles.rootCarousel,
    style: {
      '--media-bar-carousel-gap': `${carouselGap}px`
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootCarouselViewport,
    ref: emblaRef
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootCarouselContainer
  }, partners.map((partner, index) => renderPartner(partner, index)))), scrollSnaps.length > 1 && /*#__PURE__*/React.createElement("div", {
    className: styles.rootArrows
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: `${styles.rootArrow} ${styles.rootArrowPrev}`,
    onClick: scrollPrev,
    disabled: !canScrollPrev,
    "aria-label": "Poprzedni partner"
  }, /*#__PURE__*/React.createElement(ArrowLeftIcon, null)), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: `${styles.rootArrow} ${styles.rootArrowNext}`,
    onClick: scrollNext,
    disabled: !canScrollNext,
    "aria-label": "Nast\u0119pny partner"
  }, /*#__PURE__*/React.createElement(ArrowRightIcon, null))), scrollSnaps.length > 1 && /*#__PURE__*/React.createElement("div", {
    className: styles.rootDots
  }, partners.map((_, index) => /*#__PURE__*/React.createElement("span", {
    key: `media-bar-dot-${index}`,
    className: `${styles.rootDot} ${index === selectedIndex ? styles.rootDotActive : ''}`,
    onClick: () => scrollTo(index),
    "aria-label": `Przejdź do partnera ${index + 1}`,
    "aria-current": index === selectedIndex ? 'true' : undefined
  }))))));
};
export default MediaBar;